import { render, staticRenderFns } from "./FrequenciesModal.vue?vue&type=template&id=445ec556&"
import script from "./FrequenciesModal.vue?vue&type=script&lang=js&"
export * from "./FrequenciesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports